import { Injectable, signal, computed } from '@angular/core';
import { Language } from 'src/app/master-data/master-data.model';

@Injectable({ providedIn: 'root' })
export class TranslationSettingsService {
  private readonly _selectedLanguages = signal<Language[]>([]);
  readonly selectedLanguages = this._selectedLanguages.asReadonly();

  readonly selectedLocales = computed(() =>
    this._selectedLanguages().map(lang => lang.locale)
  );

  setSelectedLanguages(languages: Language[]): void {
    this._selectedLanguages.set(languages);
  }

  toggleLanguage(language: Language): void {
    const current = this._selectedLanguages();
    const exists = current.some(l => l.locale === language.locale);

    this._selectedLanguages.set(
      exists
        ? current.filter(l => l.locale !== language.locale)
        : [...current, language]
    );
  }

  isSelected(locale: string): boolean {
    return this._selectedLanguages().some(l => l.locale === locale);
  }
}
